import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Form, Input, Select } from 'antd';



import CRUDE_RegionalnieOtdeleniya from '../../../objects/RegionalnieOtdeleniya/crude'
import REDUX_RegionalnieOtdeleniya from '../../../objects/RegionalnieOtdeleniya/reducer'

const { Option } = Select;

export default function SamostoyatelnayaRegistratsiyaPariFederatsii(props) {
    const dispatch = useDispatch();
    const { auth, object, form } = props;

    const RegionalnieOtdeleniya = useSelector(REDUX_RegionalnieOtdeleniya.selector.array);
    useEffect(() => {
        form.resetFields();
        CRUDE_RegionalnieOtdeleniya.read(auth, (data) => {
            if (data.length > 0) {
                dispatch(REDUX_RegionalnieOtdeleniya.actions.setArray(data));
            }
        }, 'model', 's-nazvanie=ASC');
    }, []);
    const RegionalnieOtdeleniyaOptions = RegionalnieOtdeleniya.map(i => (
        <Option key={i.ID} value={i.ID}>{i.nazvanie}</Option>
    ));
    return (
        <>
            <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    paraID: object.ID
                }}
            >
                <Form.Item
                    preserve={"true"}
                    hidden={true}
                    name={"paraID"}
                    label={"Пара"}
                    rules={[{ required: true, message: 'Укажите пару!' }]}
                >
                    <Input disabled />
                </Form.Item>
                <Form.Item
                    name={"regionalnoeOtdelenieID"}
                    label={"Региональное отделение"}
                    rules={[{ required: true, message: 'Укажите региональное отделение!' }]}
                >
                    <Select showSearch
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }>
                        {RegionalnieOtdeleniyaOptions}
                    </Select>
                </Form.Item>
            </Form>
        </>
    );
}
